export const information = {
  title: 'Trova il tuo benessere con un clic',
  description: 'Con GurYou, prenota facilmente i tuoi servizi di benessere preferiti ovunque e in qualsiasi momento.',
  newTag: {
    description: "Scarica Ora l'App per il Tuo Benessere!",
    url: '/',
  },
};
